/**
 * Las capas de Polaris (menús, modales, tooltips, avisos) heredan el tema de la página.
 *
 * 🪤 CADA CAPA VUELVE A LOS COLORES DE FÁBRICA: Portal envuelve lo que abre en un ThemeProvider
 *    (`<div class="p-theme-light" data-portal-id>`), y la regla `:root,.p-theme-light` de Polaris declara ahí
 *    de nuevo todas sus variables claras. Una variable vale lo que diga la declaración más cercana, así que el
 *    tema se cortaba en la puerta de cada capa: el menú de tiendas salía blanco en Noche (captura del founder,
 *    21-oct), y lo mismo pasa con el modo oscuro de hoy y con el color de marca elegido.
 *
 * Se arma una regla que devuelve cada una de esas variables a «heredar». Los nombres salen de la propia hoja
 * de Polaris, no de una lista: si Polaris agrega una variable, entra sola.
 */

const ID = 'smarty-tema-capas';
const DE_FABRICA = /(^|,)\s*\.p-theme-light\s*(,|$)/;

function variablesDeFabrica(): string[] {
  const nombres = new Set<string>();
  for (const hoja of Array.from(document.styleSheets)) {
    let reglas: CSSRuleList;
    try {
      reglas = hoja.cssRules;
    } catch {
      continue; // hoja de otro origen (fuentes): no se puede leer
    }
    for (const regla of Array.from(reglas)) {
      if (!(regla instanceof CSSStyleRule) || !DE_FABRICA.test(regla.selectorText)) continue;
      for (const propiedad of Array.from(regla.style)) if (propiedad.startsWith('--p-')) nombres.add(propiedad);
    }
  }
  return Array.from(nombres);
}

function intentar(): boolean {
  if (document.getElementById(ID)) return true;
  const nombres = variablesDeFabrica();
  if (nombres.length === 0) return false;
  const estilo = document.createElement('style');
  estilo.id = ID;
  estilo.textContent = `.p-theme-light[data-portal-id]{${nombres.map((n) => `${n}:inherit`).join(';')}}`;
  document.head.appendChild(estilo);
  return true;
}

/*
 * 🪤 POLARIS CARGA SUS ESTILOS DESPUÉS: main.tsx los importa recién después de iniciarTema(). Si todavía no
 *    están, se espera a que aparezcan en <head> (en desarrollo, un <style>; armado, un <link> que hay que
 *    esperar a que termine de cargar para poder leerlo).
 */
export function heredarEnLasCapas(): void {
  if (intentar()) return;
  const terminar = () => {
    observador.disconnect();
    document.removeEventListener('load', alCargar, true);
  };
  const alCargar = (e: Event) => {
    if ((e.target as Element | null)?.tagName === 'LINK' && intentar()) terminar();
  };
  const observador = new MutationObserver(() => {
    if (intentar()) terminar();
  });
  observador.observe(document.head, { childList: true });
  document.addEventListener('load', alCargar, true);
}
